import React, { useState } from 'react';

import {
    Card,
    Row,
    Col,
    Select,
    Input,
    Button,
    Typography,
    Tabs,
    message,
    Divider,
    Tag,
    Space,
    Flex,
    Grid
}
    from 'antd';

const { useBreakpoint } = Grid;

import {
    QrcodeOutlined,
    DeleteOutlined,
    EditOutlined,
    CheckCircleFilled
} from '@ant-design/icons';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    setQrCode,
    setParsedValues,
    setFormField
} from '../cuttingLogicSlice';


const {
    Title,
    Text
} = Typography;


const QRParser = () => {

    const dispatch = useDispatch();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const {
        manufacturers,
        parserManufacturer,
        logicList,
        qrCode,
        parsedGtin,
        parsedBatch,
        parsedExpiry,
        parsedSerial
    } = useSelector(
        s => s.cuttingLogic
    );



    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('manual');
    const [manualQrCode, setManualQrCode] = useState('');


    const clearParsed = () => {
        dispatch(
            setParsedValues({
                gtin: '',
                batch: '',
                expiry: '',
                serial: ''
            })
        );
    };


    const clearAll = () => {

        clearParsed();
        dispatch(
            setQrCode('')
        );
        setManualQrCode('');
    };



    const parseQR = (code = null) => {

        const qrCodeToParse =
            code ||
            qrCode ||
            manualQrCode;

        if (!parserManufacturer) {
            message.warning(
                'Select Manufacturer'
            );
            return;
        }

        if (!qrCodeToParse) {
            message.warning(
                'Enter QR Code'
            );
            return;
        }


        const logic =
            logicList.find(
                x =>
                    String(x.manufacture_id) === String(parserManufacturer)
            );



        if (!logic) {
            message.warning(
                'Cutting logic not configured'
            );
            return;
        }

        setLoading(true);

        try {
            const getAI = (start) =>
                qrCodeToParse.substring(
                    start - 3,
                    start - 1
                );

            const extract = (
                from,
                to
            ) =>
                qrCodeToParse.substring(
                    from - 1,
                    to
                );

            const ai01 =
                getAI(
                    logic.gtin_from
                )

            const ai10 =
                getAI(
                    logic.batch_from
                );

            const ai17 =
                getAI(
                    logic.expiry_from
                );

            const ai21 =
                getAI(
                    logic.serial_from
                );



            if (ai01 !== '01') {
                message.error(
                    'GTIN AI mismatch'
                );
                return;
            }

            if (ai10 !== '10') {
                message.error(
                    'Batch AI mismatch'
                );
                return;
            }

            if (ai17 !== '17') {
                message.error(
                    'Expiry AI mismatch'
                );
                return;
            }

            if (ai21 !== '21') {
                message.error(
                    'Serial AI mismatch'
                );
                return;
            }

            dispatch(
                setParsedValues({
                    gtin:
                        extract(
                            logic.gtin_from,
                            logic.gtin_to
                        ),
                    batch:
                        extract(
                            logic.batch_from,
                            logic.batch_to
                        ),
                    expiry:
                        extract(
                            logic.expiry_from,
                            logic.expiry_to
                        ),
                    serial:
                        extract(
                            logic.serial_from,
                            logic.serial_to
                        )
                })
            );

            message.success(
                'QR Parsed Successfully'
            );

        }

        catch {
            message.error(
                'Parse failed'
            );
        }

        finally {
            setLoading(false);
        }

    };



    const handleScannerInput = (e) => {
        const value =
            e.target.value;

        setManualQrCode(
            value
        );

        dispatch(
            setQrCode(
                value
            )
        );
        clearParsed();
    };



    const handleScannerKeyDown = (e) => {
        if (
            e.key === 'Enter'
        ) {
            e.preventDefault();
            parseQR(
                manualQrCode
            );
        }
    };



    return (
        <Card
            bordered={false}
            style={{
                borderRadius: 12,
                boxShadow:
                    '0 2px 12px rgba(0,0,0,.08)',
                marginTop: 16
            }}
            styles={{
                header: {
                    height: 'auto',
                    padding: '12px 24px',
                },
                title: {
                    overflow: 'visible',
                    whiteSpace: 'normal',
                },
            }}
            title={
                <Flex
                    align='center'
                    wrap='wrap'
                    gap={10}
                >
                    <QrcodeOutlined
                        style={{
                            color:
                                '#1677ff',
                            fontSize: 22
                        }}
                    />
                    <Title
                        level={4}
                        style={{
                            margin: 0
                        }}
                    >
                        QR Parser
                    </Title>
                    {
                        parserManufacturer &&
                        <Tag
                            color='processing'
                        >
                            {
                                manufacturers.find(
                                    x =>
                                        x.id
                                        ===
                                        parserManufacturer
                                )?.name
                            }
                        </Tag>
                    }


                    {
                        activeTab ===
                        'scanner'
                        &&
                        <Tag
                            color='purple'
                        >
                            ⚡ Scanner Ready
                        </Tag>
                    }
                </Flex>
            }
        >
            <Row gutter={[16, 16]}>
                <Col
                    xs={24}
                    md={12}
                    lg={8}
                >
                    <Text strong>
                        Manufacturer
                    </Text>

                    <Select
                        showSearch
                        style={{
                            width: '100%',
                            marginTop: 5
                        }}
                        placeholder='Select Manufacturer'
                        value={
                            parserManufacturer
                        }
                        options={
                            manufacturers.map(
                                m => ({
                                    label:
                                        m.name,
                                    value:
                                        m.id
                                })
                            )
                        }
                        onChange={
                            value => {
                                dispatch(
                                    setFormField({
                                        field:
                                            'parserManufacturer',
                                        value
                                    })
                                );
                                clearAll();
                            }
                        }
                    />
                </Col>
            </Row>



            <Tabs
                activeKey={
                    activeTab
                }

                onChange={
                    setActiveTab
                }

                style={{
                    marginTop: 20
                }}

                size={isMobile ? 'small' : 'middle'}

                items={[
                    {
                        key:

                            'manual',
                        label:
                            <Space size={4}>
                                <EditOutlined />
                                {isMobile ? 'Manual' : 'Manual Entry'}
                            </Space>
                    },

                    {
                        key:
                            'scanner',
                        label:
                            <Space size={4}>
                                ⚡
                                {isMobile ? 'Scanner' : 'Handheld Scanner'}
                            </Space>
                    }

                ]}

            />

            {

                activeTab ===
                'scanner'
                &&
                !isMobile
                &&
                <Card
                    size='small'
                    style={{
                        background:
                            '#f6ffed',
                        border:
                            '1px solid #b7eb8f',
                        borderRadius: 8,
                        marginBottom: 16,
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                    }}
                    styles={{
                        body: { boxSizing: 'border-box', maxWidth: '100%' }
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                        <CheckCircleFilled
                            style={{
                                color:
                                    '#52c41a',
                                marginTop: 4,
                                flexShrink: 0
                            }}
                        />
                        <Text
                            style={{
                                display: 'block',
                                whiteSpace: 'normal',
                                overflowWrap: 'anywhere',
                                wordBreak: 'break-word',
                                minWidth: 0,
                                maxWidth: '100%',
                                flex: '1 1 0%',
                                fontSize: isMobile ? 12 : 14
                            }}
                        >
                            Focus input field and scan QR code
                        </Text>
                    </div>
                </Card>
            }

            <Input.TextArea
                rows={4}
                value={
                    activeTab ===
                        'manual'
                        ?
                        qrCode
                        :
                        manualQrCode
                }

                disabled={
                    !parserManufacturer
                }
                placeholder='Scan or Paste QR Code'
                onChange={
                    activeTab ===
                        'manual'
                        ?
                        e => {
                            dispatch(
                                setQrCode(
                                    e.target.value
                                )
                            );
                            clearParsed();
                        }
                        :
                        handleScannerInput
                }
                onKeyDown={
                    activeTab ===
                        'scanner'
                        ?
                        handleScannerKeyDown
                        :
                        undefined
                }
            />


            <Flex
                justify='space-between'
                style={{
                    marginTop: 16
                }}
            >
                <Button
                    icon={
                        <DeleteOutlined />
                    }
                    onClick={
                        clearAll
                    }
                >
                    Clear

                </Button>


                <Button
                    type='primary'
                    icon={
                        <QrcodeOutlined />
                    }
                    loading={
                        loading
                    }
                    onClick={() => {
                        parseQR();
                    }}
                >
                    Parse QR
                </Button>
            </Flex>

            {
                parsedGtin && (
                    <>
                        <Divider />
                        <Row
                            gutter={[16, 16]}
                        >
                            {
                                [
                                    {
                                        title:
                                            'GTIN',
                                        value:
                                            parsedGtin
                                    },

                                    {
                                        title:
                                            'Batch',
                                        value:
                                            parsedBatch
                                    },
                                    {
                                        title:
                                            'Expiry',
                                        value:
                                            parsedExpiry
                                    },
                                    {
                                        title:
                                            'Serial',
                                        value:
                                            parsedSerial
                                    }
                                ]
                                    .map(
                                        item => (
                                            <Col
                                                xs={24}
                                                sm={12}
                                                lg={6}
                                            >
                                                <Card
                                                    size='small'
                                                    style={{
                                                        borderRadius: 10
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontWeight: 600,
                                                            fontSize: 14,
                                                            color: '#262626',
                                                            marginBottom: 8
                                                        }}
                                                    >
                                                        {
                                                            item.title
                                                        }
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 14,
                                                            color: '#595959',
                                                            wordBreak:
                                                                'break-all'
                                                        }}
                                                    >
                                                        {
                                                            item.value
                                                        }
                                                    </div>
                                                </Card>
                                            </Col>
                                        )
                                    )
                            }
                        </Row>
                    </>
                )
            }
        </Card>
    );
};

export default QRParser;